const api = {
  Login: '/user/login',
  Register: '/user/register',
  UserInfo: '/user/info',
  EditUserInfo: '/user/info',
  EditUserAvatar: '/user/avatar',
  UpdateRolePermission: '/admin/role/permission',
  AllUserList: '/user/search',

  // 项目卡片
  ItemList: '/item/itemlist',
  CreateItem: '/item/create',
  DeleteItem: '/item/delete',
  ItemInfo: '/item/iteminfo',
  EditItem: '/item/alter',
  TransferItem: '/item/transfer',
  ItemCollection: '/item/trash',
  ItemRecover: '/item/recover',

  // 项目相关
  DeleteProjectUser: '/item/delmember',
  AddProjectUser: '/item/adduser',
  ProjectUserList: '/item/memberlist',
  UpdatePermission: '/item/authorize',

  HospitalList: '/item/data/source/list',
  AddHospital: '/item/data/source',
  EditHospital: '/item/data/source',
  DeleteHospital: '/item/data/source',

  // 标注菜单
  MyTaskList: '/member/task/list',
  ManagerTaskList: '/item/manager/task/list',
  Confirm: '/item/manager/task/confirm',
  MemberLocalLabel: '/item/manager/datalabel/local',
  MemberGlobalLabel: '/item/manager/datalabel/global',

  // 采集数据
  DataList: '/item/data/collection/list',
  AddFile: '/item/data/collection/info',
  AddData: '/item/data/collection',
  EditData: '/item/data/collection',
  DeleteData: '/item/data/collection',

  // 管理数据
  AssignDataList: '/item/data/manager/list',
  UserStatisticsList: '/item/data/manager/statistic/list',
  AssignTask: '/item/manager/task/assign',
  TaskUserList: '/item/manager/task/list',
  DeleteTaskData: '/item/data/manager',
  DeleteTask: '/item/manager/task/delete',
  EditTaskData: '/item/data/manager',

  // 模型
  AllModelList: '/model/list',
  ItemModelList: '/model/item',
  UpdateProjectModel: '/item/model',

  // 文件
  FetchFileUrl: '/file/download',
  GetFastDFSToken: '/file/token',

  // 诊断
  AddDiagnose: '/diagnose/use',
  DiagnoseList: '/diagnose/list',
  DiagnoseResult: '/diagnose/result',
  DeleteDiagnose: '/diagnose/delete',

  // 标注字典
  LabelList: '/labeldic/list',
  LabelInfo: '/labeldic',
  CreateLabel: '/labeldic/create',
  UpdateLabel: '/labeldic/update',
  DeleteLabel: '/labeldic/delete',

  // 标注
  AddLocalTag: '/datalabel/local',
  UpdateLocalTag: '/datalabel/local/',
  GetLocalTag: '/datalabel/local',
  GetAllLocalTag: '/datalabel/local/all',
  AddGlobalTag: 'datalabel/global',
  GetGlobalTag: 'datalabel/global',
  UpdateGlobalTag: 'datalabel/global',
  DeleteTag: '/datalabel/delete',

  // 统计
  ManagerDataStatistics: '/item/data/manager/statistic/list',
  AdminDataStatistics: '/item/statistics',

  // 平台管理员管理所有用户
  GetUserList: '/admin/user/list',
  CreateUser: '/admin/user/create',
  UpdateUser: '/admin/user/update',
  DeleteUser: '/admin/user',
  ResetPwd: '/admin/user/resetPwd',

  // 系统管理员管理搜有的项目的操作
  GetItemList: '/admin/item/list',

  // 获取到当前用户的管理文件的权限,使用这个token值可以获取到文件的相关的信息
  GetAdminToken: '/admin/file/token',

  NdpiImage: '/read/',

  // 获取整个的角色信息的新建、修改和删除以及整个角色信息的列表
  // 以及获取某一个用户角色的权限以及对某一个用户角色进行角色的授权
  GetRoleList: '/admin/role/list', // 所有用户角色列表
  CreateRole: '/admin/role/create', // 创建一个用户角色
  UpdateRole: '/admin/role/update', // 更新一个用户角色的信息
  DeleteRole: '/admin/role/delete', // 删除一个用户角色
  GetRolePermission: '/admin/role/permission', // 获取某一个用户角色的权限列表
  GrantPermission: '/admin/role/permission' // 对某一个用户角色进行授权

}
export default api
